export const INIT_USER_LIST = 'INIT_USER_LIST';
export const ADD_USER = 'ADD_USER';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';

export default { INIT_USER_LIST, ADD_USER, DELETE_USER, UPDATE_USER };
